<template>
    <ReactPage>
      <user-task-reaction-transaction-report-page></user-task-reaction-transaction-report-page>
    </ReactPage>
  </template>
  
  <script>
  import ReactPage from '../components/ReactPage.vue';
  
  export default {
    name: "UserTaskReactionTransactionReport",
    components: {
      ReactPage
    }
  }
  </script>